import { Typography } from '@mui/material';
import { CopyButton } from '../CopyButton';
import { IntermediaryBankFieldProps } from '../../types';
import InstructionsStyles from './Instructions.style';
import { createTranslationKey } from '../../constants';

const getFormattedKey = (key: string): string =>
  key.replace(/_/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());

export const IntermediaryBankField = ({
  fieldKey,
  value,
  t,
  onCopy,
}: IntermediaryBankFieldProps) => {
  if (!value) return null;

  const labelKey = createTranslationKey(fieldKey);
  const formattedKey = getFormattedKey(fieldKey);
  const label = t(labelKey) || formattedKey;
  const stringValue = typeof value === 'string' ? value : String(value);

  return (
    <div key={fieldKey} className={InstructionsStyles.fieldRow}>
      <Typography className={InstructionsStyles.instructionsField}>
        {label}:
      </Typography>
      <div className={InstructionsStyles.instructionsValues}>
        <Typography className={InstructionsStyles.valueText}>
          {stringValue}
        </Typography>
        {typeof value === 'string' && (
          <CopyButton label={labelKey} value={value} t={t} onCopy={onCopy} />
        )}
      </div>
    </div>
  );
};

export default IntermediaryBankField;
